export default "__VITE_ASSET__DQSWOdX___"